import Authentication from './auth.js';
import DashboardAPI from './dashboardAPI.js';
import PdfEditor from './pdfCreator.js';
import GenerateColors from './generateColors.js';

export const authentication = new Authentication();
export const dashboardAPI = new DashboardAPI();
export const pdfEditor = new PdfEditor();
export const generateColors = new GenerateColors();
